import * as AppPics from 'assets/images';
import ActionCenter from 'components/ActionCenter';
import { useEffect, useState } from 'react';

function TopHeader() {
  const [appTheme, setAppTheme] = useState(localStorage.getItem('theme') ? 'darkbg' : 'lightbg');

  useEffect(() => {
    if (appTheme === 'lightbg') {
      document.body.classList.remove('darkbg');
      document.body.classList.add('lightbg');
    }
    if (appTheme === 'darkbg') {
      document.body.classList.add('darkbg');
      document.body.classList.remove('lightbg');
    }
  }, [appTheme]);

  function fullscreen() {
    const elem = document.documentElement;
    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  }
  return (
    <div className="mainHeader">
      <div className="mainHeader__search">
        <input
          className="mainHeader__searchInput"
          placeholder="Search for something all over edpodia…"
          type="text"
        />
        <span className="mainHeader__searchBtn">
          <img src={AppPics.TopMenuSearchSvg} alt="Click to Search" />
        </span>
      </div>
      <div className="mainHeader__buttonBox">
        <button>
          <img src={AppPics.TopMenuQuestionSvg} alt="Ask help" />
          <span>Help</span>
        </button>
        <ActionCenter />
        {/* <button>
          <img src={AppPics.TopMenuBellSvg} alt="Notifications" />
          <span>Alert</span>
          <span className="menuWrap__menuIndi">5</span>
        </button> */}
        <button
          type="button"
          onClick={() => {
            if (appTheme === 'lightbg') {
              setAppTheme('darkbg');
              localStorage.setItem('theme', 'darkbg');
              return;
            }
            localStorage.removeItem('theme');
            setAppTheme('lightbg');
          }}
        >
          <img src={AppPics.TopMenuBrightnessSvg} alt="Switch theme" />
          <span>Theme</span>
        </button>
        <button onClick={(e) => fullscreen()}>
          <img src={AppPics.TopMenuFullscreenSvg} alt="Focus" />
          <span>Focus</span>
        </button>
      </div>
    </div>
  );
}

export default TopHeader;
